"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTripForPackage = void 0;
const class_validator_1 = require("class-validator");
const pageable_input_1 = require("./generic/pageable.input");
const vehicle_option_enum_1 = require("../../vehicle/enum/vehicle-option.enum");
class SearchTripForPackage extends pageable_input_1.PageableInput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SearchTripForPackage.prototype, "packageId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], SearchTripForPackage.prototype, "area", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SearchTripForPackage.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SearchTripForPackage.prototype, "end", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripForPackage.prototype, "accountKeys", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripForPackage.prototype, "businessLine", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SearchTripForPackage.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SearchTripForPackage.prototype, "duration", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SearchTripForPackage.prototype, "distance", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(['BERLINE', 'BUSINESS', 'VAN', 'VAO', 'MOTO', 'GREEN', 'TAXI', 'TAXI_VAN', 'TAXI_CONV', 'ACCESS', 'VAN_ACCESS'], { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripForPackage.prototype, "panel", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SearchTripForPackage.prototype, "packageOnly", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SearchTripForPackage.prototype, "acceptDI", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SearchTripForPackage.prototype, "notAssignedOnly", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SearchTripForPackage.prototype, "elite", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(vehicle_option_enum_1.VEHICLE_OPTIONS, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripForPackage.prototype, "vehicleOptions", void 0);
exports.SearchTripForPackage = SearchTripForPackage;
